import React from 'react';

import { IconButton, IconButtonProps } from '@mui/material';

import { CrosshairIcon } from '~/components/icons';

export const CloseDialogButton: React.FC<IconButtonProps> = (props) => {
  return (
    <IconButton
      {...props}
      sx={{
        position: 'absolute',
        right: 8,
        top: 8,
        color: 'inherit',
      }}
    >
      <CrosshairIcon sx={({ palette: { text } }) => ({
        width: 12,
        height: 12,
        transform: 'rotateY(0deg) rotate(45deg)',
        path: { fill: text.primary },
      })} />
    </IconButton>
  );
};
